module.exports = __webpack_public_path__ + "static/media/MuseoSansRounded-300.391d960e.otf";